import { useWealthSavingsSectionContent } from './useWealthSavingsSectionContent';
import { parseWealthSavingsBuildYourHeritageContent } from '../utils/wealthSavingsContent';

export const useWealthSavingsBuildYourHeritageContent = () =>
  useWealthSavingsSectionContent(parseWealthSavingsBuildYourHeritageContent);
